<app-primary-navigation></app-primary-navigation>
<iframe src="https://www.vendasta.com/developers8/?skip" height="100%" width="100%" frameborder="0">
  Your browser doesn't support iframes
  <a href="https://www.vendasta.com/developers8/?skip">click here to view the page directly.</a>
</iframe>
